import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { GreenTick, Location, Smallarw, Watch } from '../../../assests/ExportImageIcon'
import "../../hotel/hotelListing/hotelResults.css"
import '../../hotel/hotel-details/hotelDetail.css'
import EventList from '../eventList/eventList'
import Modal from '../../../componants/modal/Modal'
import ReviewsRatingSection from '../../../componants/reviewsRating/ReviewsRatingSection'
import SaveToWishlistButton from '../../../componants/wishlist/SaveToWishlistButton'
import useIndividualWishlistItems, { wishlistItemKey } from '../../../componants/wishlist/useIndividualWishlistItems'
import service from '../../../services/service'
import endpoints from '../../../services/endpoints'
import { useDispatch } from 'react-redux'
import { setSelectedEvent } from '../../../redux/eventBooking/eventBookingSlice'
import '../../profile/privacySecurity/helpSupport.css'
import "./eventDetail.css"

const AccordionChevron = ({ open }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ transform: open ? 'rotate(180deg)' : 'none', transition: '.2s ease' }}>
        <path d="M4 6l4 4 4-4" stroke="#026D4D" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

// About description is clamped to 2 lines — "Read more" shows up whenever the text
// is long enough to likely be truncated by that clamp (a plain character-count check,
// not a scrollHeight/clientHeight DOM measurement — that measurement runs before web
// fonts finish loading and can under-report overflow, hiding the button even when the
// text is actually cut off). Clicking it expands the text in place and turns into "Read less".
const ABOUT_READ_MORE_THRESHOLD = 160

const EventAbout = ({ text }) => {
    const [expanded, setExpanded] = useState(false)
    const overflowing = (text || '').length > ABOUT_READ_MORE_THRESHOLD

    return (
        <>
            <p className={`aboutProperty__desc eventAbout__desc ${expanded ? 'eventAbout__desc--expanded' : ''}`}>{text}</p>
            {overflowing && (
                <button type='button' className='eventAbout__readMore' onClick={() => setExpanded((prev) => !prev)}>
                    {expanded ? 'READ LESS' : 'READ MORE'}
                </button>
            )}
        </>
    )
}

const formatEventSchedule = (schedule) => {
    if (!schedule?.event_date) return ''
    const date = new Date(`${schedule.event_date}T00:00:00`)
    const dateLabel = Number.isNaN(date.getTime())
        ? schedule.event_date
        : date.toLocaleDateString('en-US', { weekday: 'long', day: '2-digit', month: 'short' })
    if (!schedule.start_time) return dateLabel
    const [hh, mm] = schedule.start_time.split(':')
    const hour = Number(hh)
    const period = hour >= 12 ? 'PM' : 'AM'
    const displayHour = ((hour + 11) % 12) + 1
    return `${dateLabel}, ${displayHour}:${mm} ${period}`
}

const EventDetail = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { id } = useParams()
    const [showAllAmenities, setShowAllAmenities] = useState(false)
    const [showPhotosModal, setShowPhotosModal] = useState(false)
    const [openFaqIndex, setOpenFaqIndex] = useState(0)
    const [details, setDetails] = useState(null)
    const { individualId, savedMap } = useIndividualWishlistItems()

    useEffect(() => {
        if (!id) return
        service
            .get(endpoints.customerEvents.detail.replace('{event_id}', id), {}, { silent: true })
            .then(({ data }) => setDetails(data.data))
            .catch(() => {})
    }, [id])

    const venue = details?.event_venues?.[0]
    // country/state/city on event_venues are {id, name} objects, not plain strings.
    const placeName = (place) => (typeof place === 'string' ? place : place?.name || '')
    const cheapestTicket = details?.tickets?.length
        ? [...details.tickets].sort((a, b) => Number(a.price) - Number(b.price))[0]
        : null
    // Only ever real photos from the API — banner, cover, and gallery_images[] — never dummy stock images.
    const realImages = [details?.banner_image, details?.cover_image, ...((details?.gallery_images || []).map((item) => item.image))]
        .filter(Boolean)
        .filter((src, index, arr) => arr.indexOf(src) === index)

    const venueLocationLine = venue
        ? [placeName(venue.city), placeName(venue.state), placeName(venue.country)].filter(Boolean).join(', ')
        : ''
    const venueLocationName = venue?.venue_name || venueLocationLine

    // map_link is a regular google.com/maps/place/... share link, not the /embed format —
    // Google blocks those inside an iframe (X-Frame-Options), so it can't be the iframe src.
    // Use lat/lng (or a name/city/state text search) for the embed, and offer map_link
    // separately as an "Open in Google Maps" link that opens in a new tab. No fake default
    // location when none of this data exists — the map section just doesn't render.
    const mapQuery = [venue?.venue_name, placeName(venue?.city), placeName(venue?.state)].filter(Boolean).join(', ')
    const mapEmbedSrc = venue?.latitude && venue?.longitude
        ? `https://www.google.com/maps?q=${venue.latitude},${venue.longitude}&z=14&output=embed`
        : (mapQuery ? `https://www.google.com/maps?q=${encodeURIComponent(mapQuery)}&z=14&output=embed` : null)

    const amenityItems = details?.event_amenity || []
    const aboutText = details?.detailed_desc || details?.brief_desc

    // guidelines/event_terms_conditions can be present with empty title+description — treat as "no content".
    const guidelines = details?.guidelines?.description?.trim() ? details.guidelines : null
    const terms = details?.event_terms_conditions?.description?.trim() ? details.event_terms_conditions : null
    const faqs = details?.faqs?.length ? details.faqs : []

    const handleBookNow = () => {
        if (!details) return
        dispatch(setSelectedEvent(details))
        navigate('/event-booking-detail')
    }

    const scrollToLocation = () => {
        document.getElementById('eventLocationSection')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }


    return (
        <>
            <section className='allSearchArea commonTopPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='hotelAllDetail'>
                                <div className='hotelDetailGrid'>
                                    <div className='hotelDetailLeft'>
                                        <div className='hotelGallery event__detailGallery'>
                                            {realImages.length ? (
                                                <>
                                                    <div className='hotelGallery__main'>
                                                        <img
                                                            src={realImages[0]}
                                                            alt={details?.name || 'Event'}
                                                            onClick={() => setShowPhotosModal(true)}
                                                        />
                                                        {details && (
                                                            <SaveToWishlistButton
                                                                item={{
                                                                    recordModule: 'event',
                                                                    recordId: details.id,
                                                                    recordName: details.name,
                                                                    imageUrl: realImages[0],
                                                                }}
                                                                preSavedItemId={savedMap.get(wishlistItemKey('event', details.id))}
                                                                preSavedWishlistId={individualId}
                                                            />
                                                        )}
                                                    </div>
                                                    {realImages.length > 1 && (
                                                        <div className='hotelGallery__grid'>
                                                            {realImages[1] && <img src={realImages[1]} alt={details?.name || 'Event'} onClick={() => setShowPhotosModal(true)} />}
                                                            {realImages[2] && <img src={realImages[2]} alt={details?.name || 'Event'} onClick={() => setShowPhotosModal(true)} />}
                                                            {realImages[3] && <img src={realImages[3]} alt={details?.name || 'Event'} onClick={() => setShowPhotosModal(true)} />}
                                                            <div className='hotelGallery__lastItem'>
                                                                {realImages[4] && <img src={realImages[4]} alt={details?.name || 'Event'} onClick={() => setShowPhotosModal(true)} />}
                                                                <button type='button' className='hotelGallery__showAll' onClick={() => setShowPhotosModal(true)}>Show all photos</button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className='eventGallery__placeholder'>No photos available yet</div>
                                            )}
                                        </div>

                                        <div className='hotelInfoCard'>
                                                <div className='hotelInfoCard__top'>

                                                    <div>
                                                        {(details?.category?.name || details?.subcategory?.name) && (
                                                            <div className='eventCategoryBadges'>
                                                                {details?.category?.name && (
                                                                    <span className='cardTags eventCategoryBadge'>
                                                                        <span className='cardLabel'>{details.category.name}</span>
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                        <div className='hotelInfoCard__name'>{details?.name}</div>
                                                        {details?.schedules?.[0] && (
                                                            <div className='hotelCard__dateTime'>
                                                                {formatEventSchedule(details.schedules[0])}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* No rating/review fields on GET /customer_events/{id}/ — nothing real to show yet. */}
                                                </div>

                                                {venueLocationName && (
                                                    <>
                                                        <div className='hotelInfoCard__divider' />

                                                        <div className='hotelInfoCard__location'>
                                                            <span className='hotelInfoCard__locationIcon'>
                                                                <img src={Location} alt="" />
                                                            </span>
                                                            <div className='hotelCard__location'>
                                                                <div>
                                                                    <div className='hotelCard__locationName'>{venueLocationName}</div>
                                                                    {venue?.address && (
                                                                        <div className='hotelCard__locationNote'>{venue.address}</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <button type='button' className='hotelInfoCard__arrow' aria-label="View location" onClick={scrollToLocation}>
                                                                <img src={Smallarw} alt="" />
                                                            </button>
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                    </div>

                                        <div className='hotelDetailRight'>
                                            <div className='hotelRoomCard'>
                                                <div className='hotelRoomCard__title'>{details?.name}</div>

                                                {(details?.language_name || details?.minimum_age > 0 || details?.event_format || details?.guardian_required_below > 0) && (
                                                    <ul className='hotelRoomCard__perks'>
                                                        {details?.language_name && <li><img src={Watch} alt="" />Event will be in {details.language_name}</li>}
                                                        {details?.minimum_age > 0 && <li><img src={Watch} alt="" />Entry allowed for ages {details.minimum_age} and above</li>}
                                                        {details?.event_format && <li><img src={Watch} alt="" />Event format: {details.event_format}</li>}
                                                        {details?.guardian_required_below > 0 && <li><img src={Watch} alt="" />Guardian required below age {details.guardian_required_below}</li>}
                                                    </ul>
                                                )}

                                                {cheapestTicket && (
                                                    <div className='hotelRoomCard__priceBlock'>
                                                        <div className='hotelRoomCard__price'>
                                                            ₹{Number(cheapestTicket.price).toLocaleString('en-IN')}
                                                            <span>{cheapestTicket.name}</span>
                                                        </div>
                                                    </div>
                                                )}

                                                <button type='button' className='commonBtn w-100' disabled={!details} onClick={handleBookNow}>
                                                    Book Now
                                                </button>
                                            </div>
                                        </div>

                                </div>
                            </div>
                        </div>

                        {aboutText && (
                            <div className='col-md-12'>
                                <div className='bsSectionTitle'>About This Event</div>
                                <div className='aboutProperty bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    <EventAbout text={aboutText} />
                                </div>
                            </div>
                        )}

                        <div className='col-md-12'>
                            <ReviewsRatingSection service='event' objectId={details?.id ?? id} />
                        </div>

                        {amenityItems.length > 0 && (
                            <div className='col-md-12'>
                                <div className='amenities__head'>
                                    <div className='bsSectionTitle'>Amenities</div>
                                    {amenityItems.length > 6 ? (
                                        <button
                                            type='button'
                                            className='tripSecureViewAll'
                                            onClick={() => setShowAllAmenities((prev) => !prev)}
                                        >
                                            {showAllAmenities ? 'Show Less' : 'View All'}
                                        </button>
                                    ) : null}
                                </div>
                                <div className='amenities'>
                                    <div className='amenities__row bgWhite commonBorder borderRadius20 paddingCommon20'>
                                        {/* event_amenity has no icon field — GreenTick reused for all real entries. */}
                                        {(showAllAmenities ? amenityItems : amenityItems.slice(0, 6)).map((item, index) => (
                                            <div className='amenities__item' key={item.id ?? index}>
                                                <img src={GreenTick} alt="" />
                                                <span>{item.name}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        {guidelines && (
                            <div className='col-md-12'>
                                <div className='bsSectionTitle'>Guidelines</div>
                                <div className='aboutProperty bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    {guidelines.title && guidelines.title !== 'Guidelines' && (
                                        <div className='hotelCard__name mb-2'>{guidelines.title}</div>
                                    )}
                                    <p className='aboutProperty__desc mb-0'>{guidelines.description}</p>
                                </div>
                            </div>
                        )}

                        {faqs.length > 0 && (
                            <div className='col-md-12'>
                                <div className='bsSectionTitle'>Frequently Asked Questions</div>
                                <div className='helpFaqList'>
                                    {faqs.map((faq, index) => (
                                        <div
                                            className='bgWhite commonBorder borderRadius20 paddingCommon20 helpFaqItem'
                                            key={faq.id ?? index}
                                            onClick={() => setOpenFaqIndex(openFaqIndex === index ? -1 : index)}
                                        >
                                            <div className='helpFaqItem__head'>
                                                <span className='helpFaqItem__q'>{faq.title}</span>
                                                <AccordionChevron open={openFaqIndex === index} />
                                            </div>
                                            {openFaqIndex === index && <p className='helpFaqItem__a'>{faq.description}</p>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {terms && (
                            <div className='col-md-12'>
                                <div className='bsSectionTitle'>Terms &amp; Conditions</div>
                                <div className='aboutProperty bgWhite commonBorder borderRadius20 paddingCommon20'>
                                    {terms.title && terms.title !== 'Terms & Conditions' && (
                                        <div className='hotelCard__name mb-2'>{terms.title}</div>
                                    )}
                                    <p className='aboutProperty__desc mb-0'>{terms.description}</p>
                                </div>
                            </div>
                        )}

                        {venue && (
                            <div className='col-md-12' id='eventLocationSection'>
                                <div className='bsSectionTitle'>Location</div>
                                <div className='hotelLocation bgWhite commonBorder borderRadius20 paddingCommon20'>

                                    <div className='hotelLocation__grid'>
                                        <div className='hotelLocation__left'>
                                            {venue?.address && (
                                                <div className='hotelLocation__address'>
                                                    <strong>Address:</strong> {venue.address}
                                                </div>
                                            )}
                                            {venueLocationLine && (
                                                <div className='hotelCard__locationNote'>{venueLocationLine}</div>
                                            )}

                                            {/* No structured nearby-landmarks API for events — venue.landmarks (if the
                                                vendor filled it in) is a single freeform text blob, not a distance list. */}
                                            {venue?.landmarks ? (
                                                <p className='hotelCard__locationNote mt-2'>{venue.landmarks}</p>
                                            ) : null}
                                        </div>

                                        {mapEmbedSrc && (
                                            <div className='hotelLocation__map'>
                                                <iframe
                                                    title='Event Location'
                                                    src={mapEmbedSrc}
                                                    loading='lazy'
                                                    allowFullScreen
                                                />
                                                {venue?.map_link ? (
                                                    <a
                                                        href={venue.map_link}
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                        className='hotelInfoCard__arrow eventOpenMapsLink'
                                                    >
                                                        Open in Google Maps ↗
                                                    </a>
                                                ) : null}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <EventList heading="Explore Events" />

                    </div>

                </div>

            </section>

            <Modal open={showPhotosModal} onClose={() => setShowPhotosModal(false)} maxWidth={800}>
                <div className='bsSectionTitle mb-2'>All Photos</div>
                <div className='eventPhotosModal__grid'>
                    {realImages.map((src, index) => (
                        <img key={src + index} src={src} alt={`${details?.name || 'Event'} ${index + 1}`} />
                    ))}
                </div>
            </Modal>
        </>
    )
}

export default EventDetail;
